import util from '@bmp-vue/core/api/util'

const controller = 'LogAuditoria'

const enc = (s) => encodeURIComponent(String(s ?? '').trim())

export default Object.assign({}, util.GetCrud(controller, null), {
  ObterLogPorChavePrimaria(chavePrimaria) {
    return util.Axios.Get(`${controller}?ChavePrimaria=${enc(chavePrimaria)}`)
  },
  ObterLogPorChaveSecundaria(chaveSecundaria, nomeTabela, obterLogRegraECadastro) {
    return util.Axios.Get(`${controller}?ChaveSecundaria=${enc(chaveSecundaria)}&NomeTabela=${enc(nomeTabela)}&ObterLogRegraECadastro=${enc(obterLogRegraECadastro)}`)
  },
   ObterLogPorFiltros(usuario, nomeTabela, chavePrimaria, chaveSecundaria, dtInicio, dtFim) {
    return util.Axios.Get(`${controller}?Usuario=${enc(usuario)}&NomeTabela=${enc(nomeTabela)}&ChavePrimaria=${enc(chavePrimaria)}&ChaveSecundaria=${enc(chaveSecundaria)}&DtInicio=${enc(dtInicio)}&DtFim=${enc(dtFim)}`)
  }
})
